import {
  GET_COIN_HISTORY_START,
  GET_COIN_HISTORY_SUCCESS,
  GET_COIN_HISTORY_FAILURE,
  GET_USER_COIN_HISTORY_START,
  GET_USER_COIN_HISTORY_SUCCESS,
  GET_USER_COIN_HISTORY_FAILURE,
  GET_COIN_HISTORY_STATS_START,
  GET_COIN_HISTORY_STATS_SUCCESS,
  GET_COIN_HISTORY_STATS_FAILURE,
  CREATE_COIN_HISTORY_START,
  CREATE_COIN_HISTORY_SUCCESS,
  CREATE_COIN_HISTORY_FAILURE,
  CLEAR_COIN_HISTORY_ERROR
} from './coinHistory.type';

const initialState = {
  // General coin history
  coinHistory: [],
  pagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false
  },
  
  // User specific coin history
  userCoinHistory: [],
  userPagination: {
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false
  },
  
  // Statistics
  stats: {
    currentBalance: 0,
    totalNetCoins: 0,
    totalPurchased: 0,
    totalSpent: 0,
    breakdown: {
      admin: 0,
      trainer: 0,
      create: 0,
      edit: 0,
      upscaler: 0,
      generate: 0
    }
  },
  
  // Loading states
  loading: false,
  userLoading: false,
  statsLoading: false,
  createLoading: false,
  
  // Error states
  error: null,
  userError: null,
  statsError: null,
  createError: null,
  
  // Additional info
  typeDescription: null,
  lastCreatedHistory: null
};

const coinHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get all coin history
    case GET_COIN_HISTORY_START:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case GET_COIN_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        coinHistory: action.payload.history || [],
        pagination: action.payload.pagination || state.pagination,
        typeDescription: action.payload.typeDescription || null,
        error: null
      };
    
    case GET_COIN_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        coinHistory: []
      };

    // Get user coin history
    case GET_USER_COIN_HISTORY_START:
      return {
        ...state,
        userLoading: true,
        userError: null
      };
    
    case GET_USER_COIN_HISTORY_SUCCESS:
      return {
        ...state,
        userLoading: false,
        userCoinHistory: action.payload.history || [],
        userPagination: action.payload.pagination || state.userPagination,
        userError: null
      };
    
    case GET_USER_COIN_HISTORY_FAILURE:
      return {
        ...state,
        userLoading: false,
        userError: action.payload,
        userCoinHistory: []
      };

    // Get coin history statistics
    case GET_COIN_HISTORY_STATS_START:
      return {
        ...state,
        statsLoading: true,
        statsError: null
      };
    
    case GET_COIN_HISTORY_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        stats: action.payload || state.stats,
        statsError: null
      };
    
    case GET_COIN_HISTORY_STATS_FAILURE:
      return {
        ...state,
        statsLoading: false,
        statsError: action.payload
      };

    // Create coin history
    case CREATE_COIN_HISTORY_START:
      return {
        ...state,
        createLoading: true,
        createError: null
      };
    
    case CREATE_COIN_HISTORY_SUCCESS:
      return {
        ...state,
        createLoading: false,
        lastCreatedHistory: action.payload,
        createError: null,
        // Add the new history to the beginning of the list if it exists
        coinHistory: state.coinHistory.length > 0 
          ? [action.payload, ...state.coinHistory]
          : state.coinHistory
      };
    
    case CREATE_COIN_HISTORY_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.payload
      };

    // Clear error
    case CLEAR_COIN_HISTORY_ERROR:
      return {
        ...state,
        error: null,
        userError: null,
        statsError: null,
        createError: null
      };

    default:
      return state;
  }
};

export default coinHistoryReducer;